import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TabsDemo from './TabsDemo'
import TabsElement from './TabsElement'
import TabsFormBrand from './TabsFormBrand'
import { STYLE_FORM_SCHEMA } from './TabsFormStyle'
import TabsFormValue from './TabsFormValue'
import tabsIcon from './assets/tabs.svg'

export default genElementConfig(CONFIG_ELEMENTS.tabs, {
  label: t('elements.tabs.label'),
  icon: tabsIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TabsElement,
  Demo: [TabsDemo],
  FormValue: TabsFormValue,
  FormBrand: TabsFormBrand,
  EditorActions: null,
})
